<template>
  <v-text-field
    :label="$t('chapter.coordinates')"
    :value="latLngTextField"
    dense
    readonly
    outlined
  />
</template>
<script>
const COORDINATES_SIGNIFICANT_DIGITS = 6
export default {
  props: {
    latitude: Number,
    longitude: Number,
  },
  computed: {
    latLngTextField() {
      if (this.latitude != undefined && this.longitude != undefined) {
        return (
          this.latitude.toFixed(COORDINATES_SIGNIFICANT_DIGITS).toString() + ", " + this.longitude.toFixed(COORDINATES_SIGNIFICANT_DIGITS).toString()
        );
      }
      return " ";
    },
  }
};
</script>